var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"info-page edit-list-page"},[_c('Row',{attrs:{"id":"printDom"}},[_c('Col',{attrs:{"span":"24"}},[_c('Form',{ref:"transValidate",staticClass:"list-form",attrs:{"id":"transTableForm"}},[_c('Table',{ref:"transTable",attrs:{"max-height":_vm.fixedHeader ? _vm.tableHeight : '',"row-class-name":_vm.rowClassName,"columns":_vm.transColumns,"data":_vm.transList,"border":"","show-summary":"","summary-method":_vm.handleSummary,"loading":_vm.isListLoading},scopedSlots:_vm._u([{key:"transDt",fn:function(ref){
var row = ref.row;
var index = ref.index;
return [_c('span',[_vm._v(_vm._s(_vm.formatDateToDay(row.transDt)))])]}},{key:"transSummary",fn:function(ref){
var row = ref.row;
var index = ref.index;
return [_c('span',[_vm._v(_vm._s(row.transSummary))])]}},{key:"entityId",fn:function(ref){
var row = ref.row;
var index = ref.index;
return [_c('span',[_vm._v("\n                "+_vm._s((_vm.item = _vm.projSettleEntityList.find(function (entity) { return (entity.entityId === row.entityId); })) ? _vm.item.entityName : '')+"\n              ")])]}},{key:"contractAmt",fn:function(ref){
var row = ref.row;
var index = ref.index;
return [_c('span',[_vm._v(_vm._s(_vm.formatThousandthNumber(row.contractAmt)))])]}},{key:"feeId",fn:function(ref){
var row = ref.row;
var index = ref.index;
return [_c('span',[_vm._v(_vm._s(_vm.findItemDescrByValue(_vm.feeNameDDList, row.feeId)))])]}},{key:"reimbOutputSettlAmt",fn:function(ref){
var row = ref.row;
var index = ref.index;
return [_c('span',[_vm._v(_vm._s(_vm.formatThousandthNumber(row.reimbOutputSettlAmt)))])]}},{key:"reimbOfficialSettlAmt",fn:function(ref){
var row = ref.row;
var index = ref.index;
return [_c('span',[_vm._v(_vm._s(_vm.formatThousandthNumber(row.reimbOfficialSettlAmt)))])]}},{key:"reimbTotalSettlAmt",fn:function(ref){
var row = ref.row;
var index = ref.index;
return [_c('span',[_vm._v(_vm._s(_vm.formatThousandthNumber(row.reimbOutputSettlAmt + row.reimbOfficialSettlAmt)))])]}},{key:"payPlanAmt",fn:function(ref){
var row = ref.row;
var index = ref.index;
return [_c('span',[_vm._v(_vm._s(_vm.formatThousandthNumber(row.payPlanAmt)))])]}},{key:"payDebtAmt",fn:function(ref){
var row = ref.row;
var index = ref.index;
return [_c('span',[_vm._v(_vm._s(_vm.formatThousandthNumber(row.payDebtAmt)))])]}},{key:"payAmt",fn:function(ref){
var row = ref.row;
var index = ref.index;
return [_c('span',[_vm._v(_vm._s(_vm.formatThousandthNumber(row.payAmt)))])]}},{key:"paymentId",fn:function(ref){
var row = ref.row;
var index = ref.index;
return [_c('span',[_vm._v(_vm._s(_vm.findItemDescrByValue(_vm.projSettlePaymentDDList, row.paymentId)))])]}},{key:"invAmt",fn:function(ref){
var row = ref.row;
var index = ref.index;
return [_c('span',[_vm._v(_vm._s(_vm.formatThousandthNumber(row.invAmt)))])]}},{key:"docIndex",fn:function(ref){
var row = ref.row;
var index = ref.index;
return [_c('span',[_vm._v(_vm._s('#' + _vm.formatIntMonth(row.docMth) + (row.docIndex ? '-' + row.docIndex : '')))])]}},{key:"transRemarks",fn:function(ref){
var row = ref.row;
var index = ref.index;
return [_c('span',[_vm._v(_vm._s(row.transRemarks))])]}}])})],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3d0664a6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/proj/FeeSettleTransListCard.vue
// module id = null
// module chunks = 